module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/tutorial3_0ac6ed.jpg";